import { FC } from 'react';
import { useDesign } from '@app/hooks';
import { NavLayout } from '@app/page-components/shared';
import { RouteConfig } from '@app/types';
import { filterRouteConfigs } from '@app/utilities';
import { CompoundIntentPage } from './compound/page';
import { GlobalIntentPage } from './global/page';
import { HierarchicalIntentPage } from './hierarchical/page';
import { ImportIntentPage } from './import/page';
import { IntentManagementLayout } from './management/layout';

enum IntentRoute {
  compound = 'compound',
  global = 'global',
  hierarchical = 'hierarchical',
  import = 'import',
  management = 'management'
}

type GetIntentLinksOptions = {
  managementEnabled: boolean;
};

function getRoutes({
  managementEnabled
}: GetIntentLinksOptions): RouteConfig<IntentRoute>[] {
  return [
    {
      component: IntentManagementLayout,
      condition: managementEnabled,
      isParent: true,
      path: IntentRoute.management,
      label: 'Intent Management'
    },
    {
      component: GlobalIntentPage,
      path: IntentRoute.global,
      label: 'Global Handlers'
    },
    {
      component: CompoundIntentPage,
      label: 'Compound Intents',
      path: IntentRoute.compound
    },
    {
      component: HierarchicalIntentPage,
      label: 'Hierarchical View',
      path: IntentRoute.hierarchical
    },
    {
      component: ImportIntentPage,
      label: 'Intent Import',
      path: IntentRoute.import
    }
  ];
}

export const IntentLayout: FC = () => {
  const serialized = useDesign();
  const managementEnabled = (
    serialized.rootSettings.features.intentManagement ?? false
  );

  const routes = filterRouteConfigs(getRoutes({ managementEnabled }));

  return (
    <NavLayout
      defaultRoute={(managementEnabled) ? IntentRoute.management : IntentRoute.global}
      routes={routes}
    />
  );
};
